<app-navbar>
  <ul class="navbar-nav">
    <li *ngIf="!isLoggedIn" class="nav-item">
      <div class="d-flex align-items-center">
        <a class="nav-link" routerLink="account/login" translate>Login</a>
        <span class="navbar-text px-2">/</span>
        <a class="nav-link" routerLink="account/register" translate>Register</a>
      </div>
    </li>

    <li *ngIf="isLoggedIn" class="nav-item">
      <a class="nav-link" routerLink="my-account" translate>My Account</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="find-device" translate>Sell Mobiles</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="how-it-works" translate>How It Works?</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="service-points" translate>HP Store</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="about-us" translate>About HP</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="contact" translate>Contact Us</a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="delivery-instructions" translate>Delivery Instructions for SF Express</a>
    </li>
  </ul>
</app-navbar>
